import React, { Component } from "react";
import "./ventas.css";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import moment     from 'moment'
import HeaderVentas from "../../components/header.ventas";

class UpdateCostosPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id_sucursal: '0',
      date: this.getDateGeneric(),
      countTotal: 0,
      countUpdate: 0,
      arrayListProductos: [],
      arrayListResults: [],
      valSearch: '',
      fieldUpdate: {index: -1, nombre: '', },
    }
  }

  getDateGeneric(opt) {
    // if(opt === 0)
    //   return (new Date())
    // else {
    //   let d = new Date()
      return moment().format('YYYY-MM-DD HH:mm:ss')
    // }
  }

  componentDidMount() {
    //Petition wuuuu
    this.getCostosByDate()
  }

  getCostosByDate() {
    const { id_sucursal, date, } = this.state

    const data = {
      user: 'admin',
      id_sucursal: this.props.initState.id_sucursal,
      date,
    }

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getRelationCostosByDate&section=actualiza-costos", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({ ...data, }),
    })
    .then(response => response.json())
    .then((response) => {
      let { countTotal, countUpdate, arrayListProductos, } = response
      this.setState({
        countTotal,
        countUpdate,
        arrayListProductos,
      })
    }).catch((error) => console.log(error));
  }

  render() {
    let { date, countUpdate, countTotal, valSearch, arrayListResults, fieldUpdate, } = this.state

    return (
       <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', marginTop: 0, }}>
        {/* Principal div */}
        <HeaderVentas initState={ this.props.initState } initsetState={ (param) => this.props.initsetState(param) } />

        <p className="regVentaPage__title" style={{ margin: 0, padding: 0, paddingTop: 10, }}>Actualizar costos</p>

        <Row>
          <Col className="ventaPage__colHeader" style={{}}>
            <p style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => this.goToDay(0) }>Atrás</p>
          </Col>
          <Col className="ventaPage__colHeader" style={{}}>
            <p style={{ textAlign: 'center', }}>{ moment(date).format('DD/MM/YYYY') }</p>
          </Col>
          <Col className="ventaPage__colHeader" style={{}}>
            <p style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => this.goToDay(1) }>Adelante</p>
          </Col>
        </Row>


        <p className="regVentaPage__product" style={{ padding: 0, }}>Total actualizado</p>
        <p className="regVentaPage__productPrice" style={{ padding: 0, }}>{this.number_format(countUpdate)} / {this.number_format(countTotal)}</p>
        <p style={{ cursor: 'pointer', }} onClick={ () => { this.updateAllCostos() }}>Actualizar todos</p>

        <Row>
          <Col>
            <p className="regVentaPage__title" style={{ margin: 0, padding: 0, paddingTop: 10, }}>Buscar un producto...</p>
            <input
              value={valSearch} type={"text"}
              onChange={(e) => this.onViewProduct(e.target.value) }
              style={{background: '#fff', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
            />
          </Col>
        </Row>

        <Row style={{  }}>
          <Col xs={'6'}>
            <b>Producto</b>
          </Col>
          <Col xs={'2'}>
            <b>P. Compra</b>
          </Col>
          <Col xs={'2'}>
            <b>P. Venta</b>
          </Col>
          <Col xs={'2'}>
            <b>Acciones</b>
          </Col>
        </Row>

        {
          arrayListResults.map((t,e) => (
              <Row
                onClick={ () => { /*this.selectItemProduct(t, e)*/ } }
                style={{ width: '100%', margin: '0 auto', marginTop: 10, cursor: 'auto' }}
                className="regVentaPage__content"
                key={`ws_list_compra_${e}`}
              >
                <div className="regVentaPage__separator"></div>

                <Col xs={'6'}>
                  <input style={{width: '100%', margin: 0, border: '1px solid #7CB342', borderRadius: 3, }} type="text" value={ t.folio } onChange={(inputE) => this.onChangeInputValues(3, e, inputE.target.value) } />
                  <input style={{width: '100%', margin: 0, border: '1px solid #7CB342', borderRadius: 3, }} type="text" value={ t.only_nombre } onChange={(inputE) => this.onChangeInputValues(4, e, inputE.target.value) } />
                  
                  {
                    t.update === 1 ? (
                      <span className={'updateCostosPage__badgeUpdated'}>Producto actualizado</span>
                    ) : (
                      <p style={{ width: '80%', fontSize: '.9rem', }}>Mostrando venta de la fecha <b>{ moment(t.fecha_cambio_costo).format('DD/MM/YYYY') }</b>, para confirmar pulsa el botón <b>registrar</b></p>
                    )
                  }
                </Col>
                <Col xs={'2'}>
                  <input style={{width: '100%', margin: 0, border: '1px solid #7CB342', borderRadius: 3, }} type="text" value={ t.precio_compra } onChange={(inputE) => this.onChangeInputValues(1, e, inputE.target.value) } />
                </Col>
                <Col xs={'2'}>
                  <input style={{width: '100%', margin: 0, border: '1px solid #7CB342', borderRadius: 3, }} type="text" value={ t.precio_venta } onChange={(inputE) => this.onChangeInputValues(2, e, inputE.target.value) } />
                </Col>
                <Col xs={'2'}>
                  {
                    t.processing === 1 ? (
                      <p>Procesando...</p>
                    ) : (
                      <p
                        onClick={ () => { this.updateCostosByProducto(t, e) } }
                        style={{ cursor: 'pointer', }}
                      >{ t.update === 1 ? 'Actualizar costo' : 'Registrar'}</p>
                    )
                  }
                </Col>
              </Row>
          ))
        }


      </div>
    );
  }

  goToDay(opt) {
    const { date } = this.state
    let d = new Date(date)

    const dia = moment(date).format('DD')
    if(opt === 0) {
      //Pa atrás
      let dayAnt = parseInt(dia) - 1
      if(dayAnt < 1) {
        return false
      }
      d.setDate( dayAnt )
      this.setState({
        date: moment(d).format('YYYY-MM-DD HH:mm:ss')
      }, this.getCostosByDate)
    } else {
      //Pa adelante
      let dayNext = parseInt(dia) + 1
      if(parseInt(dayNext) > 31) {
        return false
      }
      d.setDate( dayNext )
      this.setState({
        date: moment(d).format('YYYY-MM-DD HH:mm:ss')
      }, this.getCostosByDate)
    }

    // this.getCostosByDate()

  }


  onChangeInputValues(opt, index, value) {
    let { arrayListResults } = this.state

    if(opt === 1) {
      arrayListResults[index].precio_compra = value
    } else if(opt === 2) {
      arrayListResults[index].precio_venta = value
    } else if(opt === 3) {
      arrayListResults[index].folio = value
    } else if(opt === 4) {
      arrayListResults[index].only_nombre = value
    }

    this.setState({ arrayListResults })
  }

  selectItemProduct(t, e) {
    let { arrayListResults } = this.state

    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=getLastCompraVentaByIDProduct", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({ id_producto: t.id_producto, date: this.state.date }),
    })
    .then(response => response.json())
    .then((response) => {
      var date = moment( moment(response.fecha_venta).format('YYYY-MM-DD') )
      var now = moment();

      //Declaramos que no a sido actualizado por el usuario final
      let itemAutocomplete = { fecha_venta: null, id_compraventa: null, precio_compra: '', precio_venta: '', today: (now === date ? true : false), }
      if(response.length > 0) {
        itemAutocomplete = response[0]
      }
      t = {...t, ...itemAutocomplete}

      //Si today es false quiere decir que no se ha registrado
      if(!t.today) {
        //El usuario no ha registrado el valor aún
        t.isUpdated = 0
      } else {
        //Si existen deberá mquetarse sin problema
        t.isUpdated = 1
      }

      arrayListResults[e] = t
      this.setState({ fieldUpdate: {index: e, nombre: t.nombre, }, arrayListResults })
    })
  }

  updateCostosByProducto(t, e) {
    let { arrayListResults } = this.state
    t.processing  = 1
    t.dateUpdate  = this.state.date
    t.newVersion  = '32'
    t.id_sucursal = this.props.initState.signedIn.id_sucursal
    t.id_usuario  = this.props.initState.signedIn.id_usuario

    // console.log('generating', t.dateUpdate, 'ot', moment().format('YYYY-MM-DD HH:mm:ss'))
    arrayListResults[e] = t

    this.setState({ arrayListResults, })
    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setUpdateCostosByIDProducto", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({ ...t }),
    })
    .then(response => response.json())
    .then((response) => {
      if(response === 'error') {
        alert('Lo sentimos, no tienes permisos para actualizar este producto.')
        return false
      }
      t.fieldUpdate       = this.state.fieldUpdate
      t.processing        = 0
      t.update            = 1
      arrayListResults[e].nombre = t.folio + ' - ' + t.only_nombre
      arrayListResults[e] = t

      this.setState({countUpdate: response.countUpdate, arrayListResults, })
      // this.props.initState.socket.emit("toCajero", { substrace: 'updateCost', })
      // this.selectItemProduct(t, e)
    })
  }

  updateAllCostos() {
    this.setState({countUpdate: this.state.countTotal})
    /*
    fetch("https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/controllerWebApp.php?opt=setUpdateAllCostos", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify( data ),
    })
    .then(response => response.json())
    .then((response) => {

      this.setState({countUpdate: this.state.countTotal})
      // this.selectItemProduct(t, e)
    })
    */
  }

  onViewProduct(val) {
    let { arrayListProductos } = this.state

    this.setState({ valSearch: val })
    let countLimit = 0

    arrayListProductos = arrayListProductos.filter(function(producto, index) {
      if(countLimit <= 10) {
        if(typeof producto.nombre === 'undefined' || !producto.nombre) {
        } else {
          if(producto.nombre.toLowerCase().indexOf(val.toLowerCase()) !== -1) {
            countLimit++
            // producto.index = index
            return true
          }
        }
      }
    });
    this.setState({ arrayListResults: arrayListProductos });
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

};

export default withRouter(UpdateCostosPage)